// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2A9BJ","messages":"Chat_messages__1X9wn","dateDivider":"Chat_dateDivider__3OGQm"};